import React from 'react';

import { Box, H2, Icon, Tag } from '@betterment/samba-react';
import { SystemStyleObject } from '@betterment/samba-styled-system/types';
import { Flex, SectionLayout } from '@betterment/style-closet-react';
import { Link } from 'react-router-dom';

import { HeaderNav, HeaderNavProps } from './Header/HeaderNav';

interface Props {
  backLink?: { to: string; title: string; shouldReloadDocument?: boolean };
  cta?: React.ReactNode;
  navigation?: HeaderNavProps['items'];
  title: string;
  css?: SystemStyleObject;
  shouldShowTag?: boolean;
  planType?: 'standard' | 'solo';
}

export const Header: React.FC<React.PropsWithChildren<Props>> = ({
  backLink,
  title,
  cta,
  navigation,
  css: cssParam,
  shouldShowTag,
  planType,
}) => {
  const tagCopy = planType === 'solo' ? 'Solo 401(k)' : 'Standard 401(k)';
  return (
    <Box
      css={{
        bg: 'background.surface',
        mb: 'space.400',
        ...cssParam,
      }}
    >
      <SectionLayout py="3.2rem">
        <SectionLayout.ContentWrapper>
          <Box
            css={{
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 'space.300',
            }}
          >
            <Flex flexDirection="column" flexWrap="wrap" justifyContent="space-between" alignItems="start">
              {backLink && (
                <Flex.Item flex="1" paddingBottom="0.4rem">
                  {backLink.shouldReloadDocument ? (
                    <a href={backLink.to} data-testid="headerBacklink">
                      <Box css={{ display: 'flex', alignItems: 'center', justifyItems: 'center' }}>
                        <Icon name="CaretLeft" size="small" /> {backLink.title}
                      </Box>
                    </a>
                  ) : (
                    <Link to={backLink.to} data-testid="headerBacklink">
                      <Box css={{ display: 'flex', alignItems: 'center', justifyItems: 'center' }}>
                        <Icon name="CaretLeft" size="small" /> {backLink.title}
                      </Box>
                    </Link>
                  )}
                </Flex.Item>
              )}
              <Box
                as="span"
                css={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  gap: '8px',
                  justifyContent: 'center',
                }}
              >
                <H2 data-testid="headerTitle">{title}</H2>
                {shouldShowTag && <Tag accent="blue">{tagCopy}</Tag>}
              </Box>
            </Flex>
            <Box>{cta}</Box>
          </Box>
        </SectionLayout.ContentWrapper>
      </SectionLayout>
      <SectionLayout>
        <SectionLayout.ContentWrapper>{navigation && <HeaderNav items={navigation} />}</SectionLayout.ContentWrapper>
      </SectionLayout>
    </Box>
  );
};
